// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-desk-title {
  font-size: 18px;
  font-weight: 500;
  opacity: 1;
  text-align: center;
  width: 100%;
  margin-top: 20px;
}
.download-desk-subtile {
  font-size: 15px;
  opacity: 0.6;
  font-weight: 500;
  text-align: center;
  padding: 20px;
  padding-top: 10px;
  line-height: 17px;
}
.detail-dialog-shelf-location {
  margin-top: 10px;
  margin-left: 5%;
  margin-right: 5%;
  display: flex;
  flex-wrap: wrap;
}
.download-desk-feature-item {
  font-size: 15px;
  line-height: 23px;
  font-weight: 500;
  margin: 30px;
  margin-top: 10px;
  text-indent: 2rem;
}
.detail-cover {
  max-width: 150px;
  max-height: 230px;
  margin: 10px;
  z-index: 10;
}
.detail-cover-background-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;
  position: absolute;
  top: 0;
}
.detail-cover-background {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  -moz-filter: blur(50px);
  -o-filter: blur(50px);
  -ms-filter: blur(50px);
  filter: blur(50px);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
.detail-cover-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 250px;
  margin-left: 50px;
  margin-top: 20px;
}
.detail-dialog-book-info {
  overflow-y: scroll;
  height: 185px;
  line-height: 1.25;
  text-align: left;
  overflow-x: hidden;
  width: 100%;
}
.detail-dialog-book-info:hover::-webkit-scrollbar-thumb,
.detail-dialog-book-info:active::-webkit-scrollbar-thumb,
.detail-dialog-book-info:focus::-webkit-scrollbar-thumb {
  display: none;
}
.detail-dialog-book-info::-webkit-scrollbar-thumb {
  display: none;
}
.detail-dialog-book-title,
.detail-dialog-book-author,
.detail-dialog-book-desc {
  font-size: 15px;
  line-height: 18px;
}
.detail-dialog-book-title {
  margin-bottom: 5px;
  margin-top: 5px;
  text-align: center;
  padding-left: 30px;
  padding-right: 30px;
  font-size: 16px;
  line-height: 18px;
}
.detail-sub-info {
  display: flex;
  justify-content: space-around;
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
}
.detail-sub-title {
  font-size: 12px;
  opacity: 0.6;
  margin-bottom: 3px;
}
.detail-dialog-book-author {
  margin-bottom: 5px;
  text-align: center;
  opacity: 1;
  line-height: 16px;
}
.detail-sub-content-container {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail-sub-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detail-dialog-book-publisher,
.detail-dialog-book-size,
.detail-dialog-book-page,
.detail-dialog-book-added {
  text-align: center;
  line-height: 16px;
  font-size: 13px;
  max-width: 60px;
  height: 60px;
}

.detail-dialog-book-divider {
  height: 60px;
  width: 0.5px;
  margin-top: 5px;
  opacity: 0.2;
}
.detail-dialog-book-detail {
  /* width: 80%; */
  margin-top: 5px;
  font-size: 15px;
  width: 90%;
  margin-left: 5%;
  text-align: justify;
  -webkit-hyphens: auto;
          hyphens: auto;
}
.detail-dialog-book-desc {
  opacity: 0.6;
  margin-left: 5%;
  margin-top: 10px;
}
.detail-close-button {
}
.download-desk-container {
  width: 346px;
  height: 480px;
  position: absolute;
  left: calc(50vw - 173px);
  top: calc(50vh - 240px);
  z-index: 20;
  animation: popup 0.1s ease-in-out 0s 1;
  border-radius: 5px;
}
.tip-close-icon {
  margin-top: 10px;
  margin-right: 10px;
}
.download-desk-animation {
  position: absolute;
  left: 70px;
  bottom: 10px;
  z-index: -1;
}
.download-desk-title {
  font-size: 18px;
  font-weight: 500;
  opacity: 1;
  text-align: center;
  width: 100%;
  margin-top: 20px;
}
.download-desk-subtile {
  font-size: 15px;
  opacity: 0.6;
  font-weight: 500;
  text-align: center;
  padding: 20px;
  padding-top: 10px;
  line-height: 17px;
}
.download-desk-feature-item {
  font-size: 15px;
  line-height: 23px;
  font-weight: 500;
  margin: 30px;
  margin-top: 10px;
  text-indent: 2rem;
}
.download-desk-button {
  width: 100px;
  height: 32px;
  opacity: 1;
  line-height: 32px;
  text-align: center;
  margin: 12px 175px;
  position: absolute;
  cursor: pointer;
  z-index: 25;
  border-radius: 16px;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/detailDialog/updateInfo.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EAEvB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;;;EAGE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;EAIE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,qBAAa;UAAb,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;AACA;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".download-desk-title {\n  font-size: 18px;\n  font-weight: 500;\n  opacity: 1;\n  text-align: center;\n  width: 100%;\n  margin-top: 20px;\n}\n.download-desk-subtile {\n  font-size: 15px;\n  opacity: 0.6;\n  font-weight: 500;\n  text-align: center;\n  padding: 20px;\n  padding-top: 10px;\n  line-height: 17px;\n}\n.detail-dialog-shelf-location {\n  margin-top: 10px;\n  margin-left: 5%;\n  margin-right: 5%;\n  display: flex;\n  flex-wrap: wrap;\n}\n.download-desk-feature-item {\n  font-size: 15px;\n  line-height: 23px;\n  font-weight: 500;\n  margin: 30px;\n  margin-top: 10px;\n  text-indent: 2rem;\n}\n.detail-cover {\n  max-width: 150px;\n  max-height: 230px;\n  margin: 10px;\n  z-index: 10;\n}\n.detail-cover-background-container {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: -1;\n  position: absolute;\n  top: 0;\n}\n.detail-cover-background {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  -webkit-filter: blur(50px);\n  -moz-filter: blur(50px);\n  -o-filter: blur(50px);\n  -ms-filter: blur(50px);\n  filter: blur(50px);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n}\n.detail-cover-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 250px;\n  height: 250px;\n  margin-left: 50px;\n  margin-top: 20px;\n}\n.detail-dialog-book-info {\n  overflow-y: scroll;\n  height: 185px;\n  line-height: 1.25;\n  text-align: left;\n  overflow-x: hidden;\n  width: 100%;\n}\n.detail-dialog-book-info:hover::-webkit-scrollbar-thumb,\n.detail-dialog-book-info:active::-webkit-scrollbar-thumb,\n.detail-dialog-book-info:focus::-webkit-scrollbar-thumb {\n  display: none;\n}\n.detail-dialog-book-info::-webkit-scrollbar-thumb {\n  display: none;\n}\n.detail-dialog-book-title,\n.detail-dialog-book-author,\n.detail-dialog-book-desc {\n  font-size: 15px;\n  line-height: 18px;\n}\n.detail-dialog-book-title {\n  margin-bottom: 5px;\n  margin-top: 5px;\n  text-align: center;\n  padding-left: 30px;\n  padding-right: 30px;\n  font-size: 16px;\n  line-height: 18px;\n}\n.detail-sub-info {\n  display: flex;\n  justify-content: space-around;\n  width: 90%;\n  margin-left: 5%;\n  margin-top: 20px;\n}\n.detail-sub-title {\n  font-size: 12px;\n  opacity: 0.6;\n  margin-bottom: 3px;\n}\n.detail-dialog-book-author {\n  margin-bottom: 5px;\n  text-align: center;\n  opacity: 1;\n  line-height: 16px;\n}\n.detail-sub-content-container {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.detail-sub-content {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.detail-dialog-book-publisher,\n.detail-dialog-book-size,\n.detail-dialog-book-page,\n.detail-dialog-book-added {\n  text-align: center;\n  line-height: 16px;\n  font-size: 13px;\n  max-width: 60px;\n  height: 60px;\n}\n\n.detail-dialog-book-divider {\n  height: 60px;\n  width: 0.5px;\n  margin-top: 5px;\n  opacity: 0.2;\n}\n.detail-dialog-book-detail {\n  /* width: 80%; */\n  margin-top: 5px;\n  font-size: 15px;\n  width: 90%;\n  margin-left: 5%;\n  text-align: justify;\n  hyphens: auto;\n}\n.detail-dialog-book-desc {\n  opacity: 0.6;\n  margin-left: 5%;\n  margin-top: 10px;\n}\n.detail-close-button {\n}\n.download-desk-container {\n  width: 346px;\n  height: 480px;\n  position: absolute;\n  left: calc(50vw - 173px);\n  top: calc(50vh - 240px);\n  z-index: 20;\n  animation: popup 0.1s ease-in-out 0s 1;\n  border-radius: 5px;\n}\n.tip-close-icon {\n  margin-top: 10px;\n  margin-right: 10px;\n}\n.download-desk-animation {\n  position: absolute;\n  left: 70px;\n  bottom: 10px;\n  z-index: -1;\n}\n.download-desk-title {\n  font-size: 18px;\n  font-weight: 500;\n  opacity: 1;\n  text-align: center;\n  width: 100%;\n  margin-top: 20px;\n}\n.download-desk-subtile {\n  font-size: 15px;\n  opacity: 0.6;\n  font-weight: 500;\n  text-align: center;\n  padding: 20px;\n  padding-top: 10px;\n  line-height: 17px;\n}\n.download-desk-feature-item {\n  font-size: 15px;\n  line-height: 23px;\n  font-weight: 500;\n  margin: 30px;\n  margin-top: 10px;\n  text-indent: 2rem;\n}\n.download-desk-button {\n  width: 100px;\n  height: 32px;\n  opacity: 1;\n  line-height: 32px;\n  text-align: center;\n  margin: 12px 175px;\n  position: absolute;\n  cursor: pointer;\n  z-index: 25;\n  border-radius: 16px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
